export default ({key, keyCode}) =>
  key === 'Escape' || key === 'Esc' || keyCode === 27;
